import { render, staticRenderFns } from "./_panels.vue?vue&type=template&id=2ab7bfcd&lang=pug"
import script from "./_panels.vue?vue&type=script&lang=js"
export * from "./_panels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports